exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#investmentCardModal .v--modal-box.v--modal{min-height:360px!important;min-width:800px!important}#investmentCardModal .v-tabs__div:not(:last-child){padding-right:5px}#investmentCardModal .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#investmentCardModal .v-select__selection{font-size:12px!important}#investmentCardModal .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#investmentCardModal .v-tabs__wrapper--show-arrows{margin-left:0;margin-right:0}#investmentCardModal .caption--long{display:block;max-width:140px}.btnDisabled{pointer-events:none!important;color:#888!important}.btnNoDisplay{display:none!important}#investmentCardModal .datepicker--hide{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76259296","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/management/modals/InvestmentCard.vue
// module id = 2233
// module chunks = 0